import React, { FC } from 'react';
import { Lock } from '@mui/icons-material';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import API from 'api/API';
import { SetSearchResponse } from 'api/Responses/SearchResponses';
import { DraftStatus } from 'api/Responses/SetResponses';
import { StatusTile } from 'components/StatusTile/StatusTile';
import { useLanguage, useSearch } from 'context/AppContext';
import { TableContainer } from './Table';

interface SearchSetTableProps {
  sets: SetSearchResponse[];
}

export const SearchSetTable: FC<SearchSetTableProps> = ({ sets }) => {
  const navigate = useNavigate();
  const [language] = useLanguage();
  const [, dispatchSearch] = useSearch();

  const handleNavigation = async (code: string): Promise<void> => {
    try {
      // Reset the search query and navigate to the draft page
      dispatchSearch('');
      navigate(`/set/${code}`);
    } catch (error) {
      API.errorHandler(error);
    }
  };

  return (
    <>
      <h2>{language.SetTable.title}</h2>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{language.SetTable.code}</TableCell>
              <TableCell>{language.SetTable.name}</TableCell>
              <TableCell>{language.SetTable.region}</TableCell>
              <TableCell>{language.SetTable.jme}</TableCell>
              <TableCell>{language.SetTable.revision}</TableCell>
              <TableCell align="center">{language.SetTable.status}</TableCell>
              <TableCell>{language.SetTable.user}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sets.map(set => (
              <TableRow key={set.code} onClick={() => handleNavigation(set.code)}>
                <TableCell>{set.display_code}</TableCell>
                <TableCell>{set.name ?? '-'}</TableCell>
                <TableCell>{set.region}</TableCell>
                <TableCell>{set.group_desc}</TableCell>
                <TableCell>{set.revision}</TableCell>
                <TableCell>
                  {set.in_draft && (
                    <StatusTile status={DraftStatus.DRAFT}>
                      {!set.owned_by_me && <Lock fontSize="small" />}
                      {language.SetTable.draft}
                    </StatusTile>
                  )}
                </TableCell>
                <TableCell>{set.owner_email ?? '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
